export default ({ active, children }) => children.filter((child) => child.props.name === active);
